import React, { useEffect, useRef, useState } from 'react';
import POPA from '../../api/popa';
import Loading from '../loading';
import { useUserAuth } from '../../contexts/auth';
import ErrorPage from '../common/error-page';

const getAccessKey = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const accessKey = urlParams.get('code');

  return accessKey;
};

export default function Login() {
  // Fix for react strict mode running useEffect twice
  const initalized = useRef(false);
  const { updateTokenData } = useUserAuth();
  const accessKey = getAccessKey();
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function exchangeAccessKeyForTokens() {
      if (!initalized.current) {
        initalized.current = true;
        if (accessKey) {
          try {
            const tokenData = await POPA.getTokensFromTempToken(accessKey);
            updateTokenData(tokenData);
            window.location.href = '/';
          } catch (e: any) {
            setError(e);
          }
        } else {
          window.location.href = POPA.getRedirectToLogin();
        }
      }
    }
    exchangeAccessKeyForTokens();
  }, [accessKey, updateTokenData]);

  if (error) {
    const correlationId = (error.cause as any)?.correlationId;

    let message;

    if (error.message === 'invalid_grant') {
      message = (
        <>
          <p>Det verkar som att koden du använde är ogiltig.</p>
          <p>
            <a href={POPA.getRedirectToLogin()}>Var god försök igen.</a>
          </p>
        </>
      );
    }

    return <ErrorPage error={error} message={message} correlationId={correlationId} />;
  }

  return <Loading />;
}
